import { useQuery } from '@tanstack/react-query'

import { forgeApi } from '../..'
import { getForgeToken, isForgeConfigured } from '../../config'
import type { ArtifactCategory } from '../../forgeApi.types'

export const GET_ARTIFACT_CATEGORIES_QUERY_KEY = 'artifact-categories'

export const getArtifactCategories = async (): Promise<ArtifactCategory[]> => {
  const response = await forgeApi.get<{ categories: ArtifactCategory[] }>(
    '/api/v1/artifacts/categories'
  )
  return response.data.categories ?? []
}

export const useGetArtifactCategoriesQuery = () =>
  useQuery({
    queryKey: [GET_ARTIFACT_CATEGORIES_QUERY_KEY],
    queryFn: getArtifactCategories,
    enabled: isForgeConfigured() && Boolean(getForgeToken())
  })
